import { combineReducers } from "redux"

import assistants from "./assistantSlice"
import auditLogsSlice from "./auditLogsSlice"
import conversations from "./conversationSlice"
import problem from "./problemSlice"
import socket from "./socketSlice"
import userProblemDetails from "./userProblemDetailsSlice"

const assignmentReducers = combineReducers({
  assistants,
  conversations,
  userProblemDetails,
  auditLogsSlice,
  socket,
  problem,
})

export default assignmentReducers
